module.exports = {
  ALL_CUSTOM_PROPERTY_TYPES: ['MULTI_SELECT', 'SINGLE_SELECT', 'TEXT', 'NUMBER', 'DATE', 'USER'],
  APPLICABLE_ON: ['USER', 'CONTENT', 'COURSE', 'CURRICULUM', 'CHANNEL'],
  topNavigationSpacing: 64,
  learnerTopNavigationSpacing: 64,

  // -------------- DESIGN CONSTANTS -------------- //
  CONTENT_WIDTH: 1096,

  // ------------- KEYBOARD CONSTANTS ------------- //
  VK_RETURN: 13,
  VK_ESCAPE: 27,
  ActivityTypeEnum: {
    skill: 'SKILL',
    checkPoint: 'CHECKPOINT',
    liveTraining: 'LIVE_TRAINING'
  },

  SYNC_OBJECT_COMMANDS_LIMIT: 20
};
